// Sesongbasert visningsnavn for merkevaren — React-frontend-versjonen.
// Se src/lib/displayName.js (backend) for samme logikk/begrunnelse.
export function erSkiSesong(now = new Date()) {
  const maanedDag = (now.getMonth() + 1) * 100 + now.getDate(); // MMDD, f.eks. 1001 = 1. okt
  return maanedDag >= 1001 || maanedDag <= 301;
}

export function getDisplayName(now = new Date()) {
  return erSkiSesong(now) ? "Røyken Ski- og Sykkelservice" : "Røyken Sykkelservice";
}
